var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.profemina.org/","target":"_blank"}},[_c('v-img',{staticClass:"shrink mr-2",attrs:{"alt":"Profemina Logo","contain":"","src":require('@/assets/logo.png'),"transition":"scale-transition","height":"50"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }